import React from 'react';

/** Thin pastel bar with the percentage beside it. */
const RateBar: React.FC<{ value: number | null; color?: string }> = ({ value, color = '#a7e3c8' }) => (
  <div className="flex items-center gap-2 justify-end">
    <div className="h-2 w-16 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-700">
      <div className="h-full rounded-full" style={{ width: `${Math.min(value ?? 0, 100)}%`, background: color }} />
    </div>
    <span className="w-12 text-right tabular-nums text-xs text-slate-700 dark:text-slate-200">
      {value === null ? '—' : `${value}%`}
    </span>
  </div>
);

export default RateBar;
